export const FeatureToggles = {
  EnableJ4UTown: 'enableJ4UTown',
  EnableBuyPrepaidElectricity: 'enableBuyPrepaidElectricity',
  EnableAirtimeAdvance: 'enableAirtimeAdvance',
  EnableFuneralCover: 'enableFuneralCover',
  EnableWeather: 'enableWeather',
  EnableFeeds: 'enableFeeds',
  EnableSearch: 'enableSearch',
  EnableHeaderEnrichment: 'enableHeaderEnrichment',
  EnableLiteSplashPage: 'enableLiteSplashPage',
  EnableFuseAds: 'enableFuseAds',
  EnableSubscriptionLogging: 'enableSubscriptionLogging',
  EnableVouchers: 'enableVouchers',
  EnableTwitterFeed: 'enableTwitterFeed',
  EnableRedirectHandler: 'enableRedirectHandler',
  EnablePromotionBanner: 'enablePromotionBanner',
  EnablePromotions: 'enablePromotions',
  EnableSocialBundles: 'enableSocialBundles'
};

export const FeatureMenuLabels = {
  EnableWeather: 'Weather',
  EnableFeeds: 'Newsfeed',
  EnableSearch: 'Search'
};
